import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER  } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { TestComponent } from './components/test/test.component';
import { MainPageComponent } from './components/main-page/main-page.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { HttpClientModule } from '@angular/common/http';
import {MatChipsModule} from '@angular/material/chips';



import {MatTooltipModule} from '@angular/material';

// import { TooltipModule } from "ngx-tooltip";
import { LeftPanelComponent } from './components/left-panel/left-panel.component';
import { RightPanelComponent } from './components/right-panel/right-panel.component';
import { TopMenuComponent } from './components/top-menu/top-menu.component';
import { DynamicContentComponent } from './components/dynamic-content/dynamic-content.component';

// начало : попытка добавить переходы по страницам
import {Routes, RouterModule} from '@angular/router';
// определение маршрутов
/**
 * Будет падать под томкатом из-за того, что на томкат не существует страниц роутера.
 * Выдавать 404. Решение для томката, которое работает. Замкнуть на index.html в web.xml:
 *
 *  <error-page>
 *     <error-code>404</error-code>
 *     <location>/index.html</location>
 *  </error-page>
 *
 */
const appRoutes: Routes = [
  { path: '', component: HomePageComponent},
  { path: 'home', component: HomePageComponent},
  { path: 'license', component: LicenseComponent},
  { path: 'construction', component: ConstractionunitComponent},
  { path: 'psymodeler', component: BasicModelerComponent},
  { path: 'upgrade', component: UpgradeComponent},
  { path: 'kab', component: KabComponent},
  { path: '**', component: Component404Component}
];
// конец : попытка добавить переходы по страницам
import { NavigationComponent } from './components/navigation/navigation.component';


import {HomePageComponent} from './components/home-page/home-page.component';
import { LicenseComponent } from './components/pages/license/license.component';
import { ConstractionunitComponent } from './components/pages/constractionunit/constractionunit.component';
import {AhmService} from './services/ahm.service';
import {TranslateService} from './services/translate.service';
import { TranslatePipe } from './pipes/translate.pipe';
import {NavigationService} from './services/navigation.service';
import { Component404Component } from './components/component404/component404.component';
import { BasicModelerComponent } from './components/pages/basic-modeler/basic-modeler.component';
import { UpgradeComponent } from './components/pages/upgrade/upgrade.component';
import {AjaxService} from './services/ajax.service';
import { HospitalComponent } from './components/hospital/hospital.component';
import { KabComponent } from './components/pages/kab/kab.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared/shared.module';
import { DialogBodyComponent } from './components/dialog/dialog-body/dialog-body.component';
import {BuyComponent} from "./components/pages/buy/buy.component";
import {MatCardModule} from "@angular/material/card";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatSidenavModule} from "@angular/material/sidenav";
import { CommunityComponent } from './components/pages/community/community.component';
import { NewsComponent } from './components/pages/news/news.component';
import { AboutComponent } from './components/pages/about/about.component';
import { InstrumentsComponent } from './components/pages/instruments/instruments.component';
import { ConventionComponent } from './components/pages/convention/convention.component';
import { SupportComponent } from './components/pages/support/support.component';
import { WhoelseComponent } from './components/pages/whoelse/whoelse.component';
import {MatRadioModule} from "@angular/material/radio";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import { HelperComponent } from './components/pages/helper/helper.component';
import { AppsComponent } from './components/pages/apps/apps.component';
import { MenuComponent } from './components/controls/menu/menu.component';
import { PartnersComponent } from './components/pages/partners/partners.component';

/**
 * translation onload
 *
 * @param service
 */
export function setupTranslateFactory(
  service: TranslateService): Function {
  return () => service.use('en');
}

@NgModule({
  declarations: [
    AppComponent,
    TestComponent,
    MainPageComponent,
    LoginFormComponent,
    LeftPanelComponent,
    RightPanelComponent,
    TopMenuComponent,
    DynamicContentComponent,
    NavigationComponent,
    HomePageComponent,
    LicenseComponent,
    ConstractionunitComponent,
    TranslatePipe,
    Component404Component,
    BasicModelerComponent,
    UpgradeComponent,
    HospitalComponent,
    KabComponent,
    DialogBodyComponent,
    BuyComponent,
    CommunityComponent,
    NewsComponent,
    AboutComponent,
    InstrumentsComponent,
    ConventionComponent,
    SupportComponent,
    WhoelseComponent,
    HelperComponent,
    AppsComponent,
    MenuComponent,
    PartnersComponent
  ],
  exports: [
    MatTooltipModule
  ],
  imports: [
    FormsModule,
    HttpClientModule,
    // TooltipModule,
    /* попытка добавить переходы по страницам */BrowserModule,
    RouterModule.forRoot(
        appRoutes,
        {enableTracing: false}
    ),
    BrowserAnimationsModule, // <-- debugging purposes only
    SharedModule, MatCardModule, MatToolbarModule, MatSidenavModule, MatRadioModule, MatMenuModule, MatIconModule, MatChipsModule
  ],
  providers: [
    AhmService,
    TranslateService,
    NavigationService,
    AjaxService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [ TranslateService ],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogBodyComponent,
  ],
})

export class AppModule {


}
